import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'

import type { CartItemListProps } from './type'

import { DeleteFilledIcon } from '@/components/icons/DeleteFilled'
import { TextButton, DialogWarning, SectionTitle, Icon } from '@/components/ui'
import { NOTIFICATION_MESSAGE } from '@/const'
import { useClearCart } from '@/hooks/features/cart'
import { useEnterIndex, useModal, useNotification } from '@/hooks/util'

import { CartItemCardWithAddCartForm } from './CartItemCardWithAddCartForm'

export const CartItemList = ({
  cartItems,
  isVisiblePurchasePrice,
}: CartItemListProps) => {
  const { t } = useTranslation()
  const { notify } = useNotification()

  const cartClearWarningModal = useModal()

  const clearCartMutation = useClearCart({})

  const handleClearCart = () => {
    clearCartMutation.mutate(undefined, {
      onSuccess: () => {
        notify({
          id: 'NOTIFICATION_MESSAGE.CART.CLEAR',
          type: 'success',
          message: NOTIFICATION_MESSAGE.CART.CLEAR,
        })
        cartClearWarningModal.close()
      },
    })
  }

  // Note: tabIndex の挙動を enter でも行えるようにする
  useEnterIndex()

  return (
    <div className={clsx('tw-mt-6')}>
      <SectionTitle
        right={
          <TextButton variant="alert" onClick={cartClearWarningModal.open}>
            <Icon icon={DeleteFilledIcon} size={'2xl'} color={'alert'} />
            <span className={clsx('tw-text-sm')}>{`${t(
              'cart.item.action.remove'
            )}`}</span>
          </TextButton>
        }
      >
        {t('cart.item.title')}
      </SectionTitle>
      <DialogWarning
        isOpen={cartClearWarningModal.isOpen}
        title={`${t('cart.item.action.remove')}`}
        bodyText={
          <p>
            {t('cart.item.message.remove')}
            <br />
            {t('cart.item.message.notUndo')}
          </p>
        }
        confirmButtonText={t('cart.item.action.empty')}
        isLoading={clearCartMutation.isLoading}
        onCancel={cartClearWarningModal.close}
        onConfirm={handleClearCart}
      />

      <ul>
        {cartItems.map((cartItem) => (
          <li key={cartItem.item.itemCode} className={clsx('tw-mt-2')}>
            <CartItemCardWithAddCartForm
              cartItem={cartItem}
              isVisiblePurchasePrice={isVisiblePurchasePrice}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}
